import React from "react";
import { useMutation } from "react-query";
import { updateOfficeBMO } from "../../../../../actions/Utilities/OfficeBMO";
import { toast } from "../../../../../components/toastNotification";
import { OfficeBMOType } from "../types";
import { editStateOfficeBMO, officeBMOReFetching } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

export default function useUpdateOfficeBMO() {
  const setActionEditState = useSetRecoilState(editStateOfficeBMO);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeBMOReFetching
  );
  
  const { mutate } = useMutation(
    (OfficeBMO: OfficeBMOType) => updateOfficeBMO(OfficeBMO),
    {
  
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Office BMO failed",
            `${res.Message}`,
            "error"
          );
        } else {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Office BMO Updated Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed!"):
            toast.fire(
              "Success ",
              `Office BMO Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res.includes("Operation Failed!"):
            toast.fire(
              "Updating Office BMO failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res.includes("The data already exists!"):
            toast.fire(
              "Updating Office BMO failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
            case res.includes("Office BMO not found"):
            toast.fire(
                "Updating Office BMO failed ",
                `Error: ${res}`,
                "error"
            );
            break;
            case res.includes("Action object is null"):
            toast.fire(
                "Updating Office BMO failed ",
                `Error: ${res}`,
                "error"
            );
            break;
          default:
            toast.fire(
              "Updating Office BMO failed",
              `${res.Message}`,
              "error"
            );
        }
      }
        // Redirect to View
        setActionEditState(false);
        
        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Office BMO failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
}
